import { MatchedFieldSummary } from '@core/Areas/Racing/Components/FieldSummary/MatchedFieldSummary'
import { MatchedFieldSummaryResults } from '@core/Areas/Racing/Components/FieldSummary/MatchedFieldSummaryResults'
import type ObservableResultsPage from '../../../Model/Observables/ObservableResultsPage'
import type ObservableTrotFinisher from '../../../Model/Observables/ObservableTrotFinisher'
import BaseFinisherViewModel from '../BaseFinisherViewModel'

export interface Params {
  raceInformation: ObservableResultsPage
  finisher: ObservableTrotFinisher
  showField: boolean
}

export class TrotFinisherViewModel extends BaseFinisherViewModel {
  public MatchedFieldSummaryResults: typeof MatchedFieldSummaryResults
  public MatchedFieldSummary: typeof MatchedFieldSummary

  constructor(params: Params) {
    super(params)
    this.MatchedFieldSummaryResults = MatchedFieldSummaryResults
    this.MatchedFieldSummary = MatchedFieldSummary
  }
}
